// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import classNames from 'classnames'
import './EditToolPopUp.scss'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const EditToolPopUp = ({ editToolPopUpOptions, className = '', popUpContainerStyle = {} }) => (
  <div className={classNames('edit-tool-popup-container', { [className]: className })} style={popUpContainerStyle}>
    {/*
     // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
    {editToolPopUpOptions.map(({ name, onClickCallBack }) => (
      <div className='edit-tool-popup-item' key={name} onClick={onClickCallBack}>
        {name}
      </div>
    ))}
  </div>
)
